import type { TocItem } from "@/components/legal/LegalLayout";

export const TERMS_EFFECTIVE_DATE = "August 18, 2026";
export const TERMS_LAST_UPDATED = "August 12, 2026";

// The deployed revision of this document: counsel's Last Updated date, plus a
// suffix when Benmore corrects the deployed copy without a new counsel
// document (scripts/legal/README.md lists the corrections). Bumping it makes
// every existing user accept again, so it must stay identical to
// LEGAL_DOCUMENT_VERSIONS in backend/config/settings/base.py.
export const TERMS_VERSION = "2026-08-12-r2";

export const TERMS_TOC: TocItem[] = [
  { id: "section-1", label: "1. ACCEPTANCE OF TERMS" },
  { id: "section-2", label: "2. THE SERVICE" },
  { id: "section-3", label: "3. ELIGIBILITY" },
  { id: "section-4", label: "4. ACCOUNTS, SECURITY, AND COMMUNICATIONS" },
  { id: "section-5", label: "5. SUBSCRIPTIONS, BILLING, RENEWAL, AND CANCELLATION" },
  { id: "section-6", label: "6. CONNECTED FINANCIAL ACCOUNTS AND THIRD-PARTY SERVICES" },
  { id: "section-7", label: "7. FINANCIAL DISCLAIMERS" },
  { id: "section-8", label: "8. OWNERSHIP, LICENSE, USER DATA, AND FEEDBACK" },
  { id: "section-9", label: "9. ACCEPTABLE USE" },
  { id: "section-10", label: "10. PRIVACY, SECURITY, AND SERVICE AVAILABILITY" },
  { id: "section-11", label: "11. SUSPENSION AND TERMINATION" },
  { id: "section-12", label: "12. DISCLAIMER OF WARRANTIES" },
  { id: "section-13", label: "13. LIMITATION OF LIABILITY" },
  { id: "section-14", label: "14. INDEMNIFICATION" },
  { id: "section-15", label: "15. DISPUTE RESOLUTION; ARBITRATION; CLASS-ACTION WAIVER" },
  { id: "section-16", label: "16. MOBILE APPLICATIONS AND APP STORES" },
  { id: "section-17", label: "17. GENERAL TERMS" },
  { id: "section-18", label: "18. CONTACT INFORMATION" },
];
